// extracted by mini-css-extract-plugin
module.exports = {"bgAds":"bg-ads_bgAds__jtgUN"};